// import React from 'react';
import {Component} from 'react';
import CONFIG from '../global/libs/CONFIG.js';

var Link = require('react-router-dom').Link;
class NotFound extends Component {
  render() {
    return (
      <div>
        <center>
          <h1>Page Not Found</h1>
          <br />
          <img src="/character_sorry.png" alt="pagenotfound" />
          <br />
          <br />
          <p>Sorry, there is nothing to see here.</p>
          <p>
            <Link to={CONFIG.APP_ROUTE}>Back to Home</Link>
          </p>
        </center>
      </div>
    );
  }
}

export default NotFound;
